






























import Vue from 'vue'
import Component from 'vue-class-component'
import WizardStep from './WizardStep.vue'
import { IWizardSection } from '@app/componentlib/common/types/WizardTypes'
import WizardNavigation from '@app/componentlib/src/views/components/WizardNavigation.vue'
import { AppModule, PortalSettings } from '@app/componentlib/src/store/modules/app'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'
import { findReplaceString } from '@app/componentlib/src/application/helpers/findReplaceString'
import gsap from 'gsap'
import { ISettingsItem, IUserInfo } from '@app/componentlib/common/types/JobSearchTypes'
import { IJobMatchProfile } from '@app/componentlib/common/types/JobMatchTypes'
import { ProfileModule } from '@app/componentlib/src/store/modules/profile'
import { ProfileData } from '@app/componentlib/common/types/profileTypes'
import { JobMatchOccupationModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatchOccupations'

@Component<WizardSectionPage>({
  components: {
    WizardStep,
    WizardNavigation
  },
  props: {
    content: Object,
    translations: Object,
    userInfo: Object,
    profileLink: String,
    settings: Object,
    jumpToStep: String
  },
  watch: {
    numberOfJobs () {
      gsap.to(this, {
        duration: 2, // default 0.5
        ease: 'expo',
        yoyo: true,
        tweenValue: this.numberOfJobs,
        onUpdate: () => {
          if (this.tweenValue !== undefined) {
            this.displayValue = Math.ceil(this.tweenValue)
          }
        }
      })
    }
  }
})

export default class WizardSectionPage extends Vue {
  /**
   * Props variables
   */
  content: IWizardSection | undefined
  translations: object | undefined
  userInfo: IUserInfo | undefined
  profileLink: string | undefined
  settings: ISettingsItem | undefined
  jumpToStep: string | undefined

  /**
   * Component state variables
   */
  currentStep: number = 0
  totalSteps: number = 0
  tweenValue = this.numberOfJobs
  displayValue = this.numberOfJobs
  loadingComponent: boolean = true
  jumpToStepFromStorage: string = sessionStorage.getItem('stepToJumpTo') || ''
  nextButtonDisabledReason: string = ''

  /**
   * Lifecycle
   */
  async mounted() {
    console.log("wizard section content", this.content)
    AppModule.setIsMobile(window.innerWidth)

    window.onresize = () => {
      AppModule.setIsMobile(window.innerWidth)
    }

    const { init, updateJobMatchProfile } = JobMatchModule

    if (this.translations !== undefined) await AppModule.setTranslations(this.translations)
    await init(this.userInfo!)
    await updateJobMatchProfile(this.jobmatchProfile)
    const portalSettings: PortalSettings = { profileLink: this.profileLink}
    await AppModule.changePortalSettings(portalSettings)
    await ProfileModule.getProfileData()

    if (this.content?.wizardSteps !== undefined) {
      this.totalSteps = this.content?.wizardSteps?.length - 1

      if (this.jumpToStep !== undefined) {
        for(let i = 0; i < this.content?.wizardSteps.length; i++) {
          if (this.content?.wizardSteps[i].type === this.jumpToStep)
            this.currentStep = i
        }
      }

      if (this.jumpToStepFromStorage !== 'undefined' && this.jumpToStepFromStorage !== '' && this.jumpToStepFromStorage !== undefined) {
        for(let i = 0; i < this.content?.wizardSteps.length; i++) {
          if (this.content?.wizardSteps[i].type === this.jumpToStepFromStorage) {
            this.currentStep = i
            sessionStorage.removeItem('stepToJumpTo')
            // Remove parameter from url in wizard
            var url= document.location.href
            window.history.pushState({}, "", url.split("?")[0])
          }
        }
      }
    }

    this.loadingComponent = false
  }

  /**
   * Getters
   */
  get numberOfJobs (): number {
    return JobMatchModule.jobMatchCount
  }

  get matchTitle (): string {
    if(this.content?.navigationTitle !== undefined && this.content?.navigationTitle !== null && this.content?.navigationTitle !== '') {
      return findReplaceString(this.content?.navigationTitle , 'number', this.displayValue)
    } else {
      return ''
    }
  }

  get jobmatchProfile(): IJobMatchProfile {
    return JobMatchModule.jobMatchProfile
  }

  get backButtonDisabled(): boolean {
    return this.content?.backUrl === '' && this.currentStep === 0
  }

  get nextButtonDisabled(): boolean {
    let isLastStep = this.currentStep === this.totalSteps
    let isNextStepNotificationStep = this.content?.wizardSteps[this.currentStep + 1]?.type === 'wizardStepJobMatchEmailNotification'
    let noOfSelectedOccupations = JobMatchOccupationModule.selectedOccupations ? JobMatchOccupationModule.selectedOccupations.length : 0

    //Disable Next button if there is no selected occupations and the user is at the last step or before the email notification step
    if (isLastStep || isNextStepNotificationStep) {
      if (noOfSelectedOccupations === 0) {
        this.nextButtonDisabledReason = this.t.job_Match_Missing_Job_Preferences
        return true
      }
    }

    this.nextButtonDisabledReason = ''
    return false
  }

  get profile(): ProfileData | undefined {
    return ProfileModule.profileData
  }

  get t (): any {
    return AppModule.translations
  }

  /**
   * Methods
   */
  back() {
    if (this.currentStep > 0)
      this.currentStep -= 1
    else if (this.content?.backUrl !== "")
      window.location.href = this.content?.backUrl as string
  }

  next() {
    if (this.currentStep < this.totalSteps)
      this.currentStep += 1
    else if (this.content?.completionUrl !== "")
      window.location.href = this.content?.completionUrl as string
  }
}
